// Máscaras BR e ViaCEP
export function maskCPF(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function maskPhone(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) {
    return d
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{1,4})$/, "$1-$2");
  }
  return d
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
}

export function maskCEP(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 8);
  return d.replace(/(\d{5})(\d{1,3})$/, "$1-$2");
}

export function maskDate(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 8);
  return d
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
}

export function isoFromBRDate(v) {
  const d = (v || "").replace(/\D/g, "");
  if (d.length !== 8) return "";
  const dd = d.slice(0, 2), mm = d.slice(2, 4), yyyy = d.slice(4, 8);
  const D = parseInt(dd, 10), M = parseInt(mm, 10), Y = parseInt(yyyy, 10);
  if (D < 1 || D > 31 || M < 1 || M > 12 || Y < 1900 || Y > 2100) return "";
  return `${yyyy}-${mm}-${dd}`;
}

export function brDateFromISO(v) {
  if (!v) return "";
  // Aceita "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss...", ou já em DD/MM/AAAA
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) return v;
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  return `${m[3]}/${m[2]}/${m[1]}`;
}

export function unmask(v) {
  return (v || "").replace(/\D/g, "");
}

export async function lookupCEP(cep) {
  const clean = unmask(cep);
  if (clean.length !== 8) return null;
  try {
    const res = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
    if (!res.ok) return null;
    const data = await res.json();
    if (data.erro) return null;
    return {
      address: data.logradouro || "",
      neighborhood: data.bairro || "",
      city: data.localidade || "",
      state: data.uf || "",
    };
  } catch {
    return null;
  }
}

// Vencimento só-data (Next Fit) vale até 23:59:59 de Brasília, igual ao servidor e à catraca
export function endOfValidity(end) {
  if (!end) return null;
  const s = String(end);
  return new Date(s.length === 10 ? `${s}T23:59:59-03:00` : s);
}
